import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { useMemo, useState } from 'react';
import { Dialog } from '../../components/Dialog';
import { Choice } from '../../components/Choice';

export function ChooseInterpolations(props) {
  const { type, onSave, active, inactive, ...passThrough } = props;
  const title = type === 'pdf' ? 'Print Soil Report' : 'Export Soil Data';
  const [choice, setChoice] = useState('active');

  const inactiveYears = useMemo(
    () => [...new Set(inactive.map((i) => i.year))],
    [inactive],
  );

  const [selectedYears, setSelectedYears] = useState(inactiveYears);

  const chosen = useMemo(() => {
    if (choice === 'active') return active;

    if (choice === 'inactive')
      return selectedYears.flatMap((year) =>
        inactive.filter((i) => i.year === year),
      );
  }, [active, inactive, choice, selectedYears]);

  return (
    <Dialog
      title={title}
      width="xs"
      canSave={Boolean(chosen?.length)}
      onSave={onSave.bind(null, chosen)}
      {...passThrough}
    >
      <Typography variant="body1" sx={{ mt: 1 }}>
        Select the time period you wish to download
      </Typography>
      <Box
        component="ul"
        sx={{
          width: '100%',
          listStyle: 'none',
          p: 0,
          '& li': { width: '100%' },
          '& li + li': { mt: 2 },
        }}
      >
        <Choice
          option={{ label: 'Current Soil Data', value: 'active' }}
          onSelect={(selection) => setChoice(selection)}
          isSelected={choice === 'active'}
        />
        <Choice
          option={{ label: 'Historic Soil Data', value: 'inactive' }}
          onSelect={(selection) => setChoice(selection)}
          isSelected={choice === 'inactive'}
        />
        {buildYearSelector()}
      </Box>
    </Dialog>
  );

  function onYearChange(event) {
    const { value } = event.target;
    setSelectedYears(value.split ? value.split(',') : value);
  }

  function onYearDelete(value) {
    setSelectedYears((current) => current.filter((year) => year !== value));
  }

  function allowChipDeletes(event) {
    const { classList } = event.target;

    if (!classList.length || classList.contains('MuiChip-deleteIcon')) {
      event.stopPropagation();
    }
  }

  function buildYearSelector() {
    if (choice === 'inactive')
      return (
        <FormControl variant="filled" sx={{ width: '100%', mt: 2 }}>
          <InputLabel id="select-year-label">Select Year</InputLabel>
          <Select
            labelId="select-year-label"
            multiple
            value={selectedYears}
            onChange={onYearChange}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip
                    key={value}
                    label={value}
                    onDelete={onYearDelete.bind(null, value)}
                    onMouseDown={allowChipDeletes}
                  />
                ))}
              </Box>
            )}
          >
            {inactiveYears.map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
  }
}
